import { render } from "./DiscountList.vue?vue&type=template&id=4fc8a0e2"
import script from "./DiscountList.vue?vue&type=script&lang=js"
export * from "./DiscountList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brian/Desktop/My Jetmall@Lear/Projects/myjetmall-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__